export function scrollToItem(type: "project" | "lesson" | "slide", id: string) {
  requestAnimationFrame(() => {
    document
      .getElementById(`${type}-${id}`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  });
}
